import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FilterSettingsModel, GridComponent, SearchSettingsModel } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';
import { catchError, filter, switchMap, tap } from 'rxjs';
import { ConfirmService } from 'src/app/libs/confirm/confirm.service';
import { ToastService } from 'src/app/libs/toast/toast.service';
import { AtendimentoService } from 'src/app/servicos/atendimento.service';
import { PessoaDoencaService } from 'src/app/servicos/pessoa-doenca.service';
import { DoencaInsercaoComponent } from '../doenca-insercao/doenca-insercao.component';
import { DoencaInativacaoComponent } from '../doenca-inativacao/doenca-inativacao.component';
import { AtendimentoAtualConfiguracao } from '../../atendimento-medico/atendimento-cadastro/atendimento-cadastro.component';
import { DoencaReativacaoComponent } from '../doenca-reativacao/doenca-reativacao.component';
import { DoencaHistoricoListaComponent } from '../doenca-historico-lista/doenca-historico-lista.component';
import { DoencaAtualizacaoComponent } from '../doenca-atualizacao/doenca-atualizacao.component';

@Component({
  selector: 'app-doenca-lista',
  templateUrl: './doenca-lista.component.html',
  styleUrls: ['./doenca-lista.component.less']
})
export class DoencaListaComponent implements OnInit {

  @ViewChild('gridAtivas')
  gridAtivas!: GridComponent;

  @ViewChild('gridInativas')
  gridInativas!: GridComponent;

  @ViewChild('doencaInsercao')
  doencaInsercao!: DoencaInsercaoComponent;

  @ViewChild('doencaInativacao')
  doencaInativacao!: DoencaInativacaoComponent;

  @ViewChild('doencaReativacao')
  doencaReativacao!: DoencaReativacaoComponent;

  @ViewChild('doencaAtualizacao')
  doencaAtualizacao!: DoencaAtualizacaoComponent;

  @ViewChild('historico')
  historico!: DoencaHistoricoListaComponent;

  @Input()
  atendimentoAtualConfiguracao: AtendimentoAtualConfiguracao | null = null;

  toolbarDoencasAtivasItens: Object[] | null = null;
  toolbarDoencasInativasItens: Object[] | null = null;

  registrosDoencasAtivas: Object | null = null;
  registrosDoencasInativas: Object | null = null;

  filterSettings: FilterSettingsModel = {
    mode: 'Immediate',
    type: 'Excel'
  }

  searchSettings: SearchSettingsModel = {
    ignoreAccent: true,
    ignoreCase: true
  }

  _atendimentoMedicoId: number | null = null;

  @Input()
  dataAtendimento: Date | null = null;

  @Input()
  pessoaId: number | null = null;

  @Input()
  set atendimentoMedicoId(id: number | null) {
    if (id === null || id <= 0) {
      this.registrosDoencasAtivas = [];
      this.registrosDoencasInativas = [];
      return;
    }

    this._atendimentoMedicoId = id;

    this.carregar();
  }

  constructor(private atendimentoServico: AtendimentoService,
    private pessoaDoenca: PessoaDoencaService,
    private toast: ToastService,
    private confirm: ConfirmService) { }

  ngOnInit(): void {
    this.toolbarDoencasAtivasItens = this.criarToolbarDoencasAtivas();
    this.toolbarDoencasInativasItens = this.criarToolbarDoencasInativas();

    this.carregar();
  }

  toobarClick(event: ClickEventArgs) {
    if (event.item.id === 'vincularDoenca') {
      this.vincularDoenca();
    }
    else if (event.item.id === 'inativarDoenca') {
      this.inativarDoenca();
    }
    else if (event.item.id === 'excluirDoenca') {
      this.excluirDoenca();
    }
    else if (event.item.id === 'reativarDoenca') {
      this.reativarDoenca();
    }
    else if (event.item.id === 'atualizarDoenca') {
      this.atualizarDoenca();
    }
    else if (event.item.id === 'historicosDoencaInativa') {
      this.abrirHistoricosDoencaInativa();
    }
    else if (event.item.id === 'historicosDoencaAtiva') {
      this.abrirHistoricosDoencaAtiva();
    }
  }

  vincularDoenca() {
    if (this.dataAtendimento === null)
      return;

    if (this.pessoaId === null)
      return;

    let x = this.atendimentoAtualConfiguracao;

    this.doencaInsercao.abrir()
      .subscribe(() => {
        this.carregar();
      });
  }

  inativarDoenca() {
    if (!this.possuiDoencasAtivasSelecionadas())
      return;

    let id = (this.gridAtivas.getSelectedRecords()[0] as any).id;

    this.doencaInativacao.abrir(id)
      .subscribe(() => {
        this.carregar();
      });
  }

  reativarDoenca() {
    if (!this.possuiDoencasInativasSelecionadas())
      return;

    let id = (this.gridInativas.getSelectedRecords()[0] as any).id;

    this.doencaReativacao.abrir(id)
      .subscribe(() => {
        this.carregar();
      });
  }

  atualizarDoenca() {
    if (!this.possuiDoencasAtivasSelecionadas())
      return;

    let id = (this.gridAtivas.getSelectedRecords()[0] as any).id;

    this.doencaAtualizacao.abrir(id)
      .subscribe(() => {
        this.carregar();
      });
  }

  abrirHistoricosDoencaAtiva() {
    if (!this.possuiDoencasAtivasSelecionadas())
      return;

    let id = (this.gridAtivas.getSelectedRecords()[0] as any).id;

    this.historico.abrir(this.atendimentoAtualConfiguracao?.pessoaId ?? 0, id)
      .subscribe(() => {
        this.carregar();
      });
  }

  abrirHistoricosDoencaInativa() {
    if (!this.possuiDoencasInativasSelecionadas())
      return;

    let id = (this.gridInativas.getSelectedRecords()[0] as any).id;

    this.historico.abrir(this.atendimentoAtualConfiguracao?.pessoaId ?? 0, id)
      .subscribe(() => {
        this.carregar();
      });
  }

  excluirDoenca() {
    if (!this.possuiDoencasAtivasSelecionadas())
      return;

    let id = (this.gridAtivas.getSelectedRecords()[0] as any).id;

    this.confirm.confirm()
      .pipe(
        filter(v => v === true),
        switchMap(() => {
          return this.pessoaDoenca.excluirDoenca(id);
        }),
        catchError(err => {
          this.toast.showWarning('Não foi possivel excluir a doença.');
          throw err;
        }),
        tap(() => {
          this.toast.showSuccess('Doença excluida com sucesso.');
          this.carregar();
        })
      )
      .subscribe();
  }

  possuiDoencasAtivasSelecionadas(): boolean {
    if (this.gridAtivas.getSelectedRecords().length === 0) {
      this.toast.showInfo('Selecione uma doença.');
      return false;
    }

    return true;
  }

  possuiDoencasInativasSelecionadas(): boolean {
    if (this.gridInativas.getSelectedRecords().length === 0) {
      this.toast.showInfo('Selecione uma doença.');
      return false;
    }

    return true;
  }

  criarToolbarDoencasAtivas(): Object[] {
    return [
      { id: 'vincularDoenca', text: 'Vincular Doença', prefixIcon: 'fal fa-plus' },
      { type: 'Separator' },
      { id: 'inativarDoenca', text: 'Inativar Doença', prefixIcon: 'fal fa-chevron-down' },
      { type: 'Separator' },
      { id: 'atualizarDoenca', text: 'Atualizar Doença', prefixIcon: 'fal fa-edit' },
      { type: 'Separator' },
      { id: 'excluirDoenca', text: 'Excluir Doença', prefixIcon: 'fal fa-times' },
      { type: 'Separator' },
      { id: 'historicosDoencaAtiva', text: 'Histórico', prefixIcon: 'fal fa-file-alt' }
    ]
  }

  criarToolbarDoencasInativas(): Object[] {
    return [
      { id: 'reativarDoenca', text: 'Reativar Doença', prefixIcon: 'fal  fa-chevron-up' },
      { type: 'Separator' },
      { id: 'historicosDoencaInativa', text: 'Histórico', prefixIcon: 'fal fa-file-alt' }
    ]
  }

  carregar() {
    if (this._atendimentoMedicoId === null)
      throw 'this._atendimentoMedicoId is null';

    this.atendimentoServico.listarDoencas(this._atendimentoMedicoId).subscribe((doencas) => {
      this.registrosDoencasAtivas = doencas.doencasAtivas;
      this.registrosDoencasInativas = doencas.doencasInativas;
    });
  }
}
